import LoadingComponent from "./loading.vue";
const Loading = {};

Loading.install = (Vue, options) => {
  let opt = {
    hasMask: true, //是否有遮罩层
    msg: "加载中" //文字
  };

  let default_opt = Object.assign({}, opt, options);

  /**
   * @method 注册插件
   * @param {Function} Vue构造器
   */
  const LoadingConstructor = Vue.extend(LoadingComponent);
  const instance = new LoadingConstructor(); //创建子实例
  instance.$mount(document.createElement("div"));
  document.body.appendChild(instance.$el);
  //默认赋值
  for (const property in default_opt) {
    instance[property] = default_opt[property];
  }

  let loading = {
    show(options) {
      instance.show = true;
      if (typeof options == "object") {
        let new_opt = Object.assign({}, default_opt, options);
        for (const property in new_opt) {
          instance[property] = new_opt[property];
        }
      } else if (typeof options === "string") {
        instance.msg = options;
      } else if (options == undefined) {
        instance.msg = "";
      }
    },
    hide() {
      instance.show = false;
    }
  };
  Vue.prototype.$loading = loading;
};

export default Loading;
